import * as React from 'react';

import classnames from 'classnames';

import {colors} from 'shells/colors/colors';

import styles from './chevron-border.module.css';

/*
 * Component to just display a "fit-to-height" chevron
 * border that's oriented to the right
 */

type Props = {
    type: 'straight' | 'bent';
    side: 'left' | 'right';
    borderColor?: string;
    bgColor?: string;
};

export class ChevronBorder extends React.PureComponent<Props> {
    static defaultProps = {
        type: 'bent',
        borderColor: colors.offWhiteDk,
        bgColor: '#fff',
    };

    render() {
        const isStraight = this.props.type === 'straight';
        const containerStylename = classnames(styles[this.props.side], {
            [styles.straight]: isStraight,
        });
        const localStyles = {
            backgroundColor: this.props.bgColor,
            borderColor: this.props.borderColor,
        } as const;

        return (
            <div style={isStraight ? localStyles : undefined} className={containerStylename}>
                {this.props.type === 'bent' ? (
                    <div style={localStyles} className={styles.before} />
                ) : null}
                {this.props.type === 'bent' ? (
                    <div style={localStyles} className={styles.after} />
                ) : null}
            </div>
        );
    }
}
